module.exports = __webpack_public_path__ + "img/banner_title.ee5a4231.png";